import { AxiosInstance } from 'axios';
import NationalEventsRepositoryInterface, {
  ApiCreateNationalEventsInterface,
  ApiUpdateNationalEventsInterface,
  NationalEventsInterface,
} from '@/services/Calendar/NationalEvents/Interfaces';

export default class NationalEventsRepository implements NationalEventsRepositoryInterface {
  private apiPrefix = '/event-calendar/national-event';

  constructor(
    private axios: AxiosInstance,
  ) {
  }

  public async getAllNationalEvents(): Promise<NationalEventsInterface[]> {
    const res = await this.axios.get(this.apiPrefix);

    return res.data;
  }

  public async getNationalEvent(id: number): Promise<NationalEventsInterface> {
    const res = await this.axios.get(`${this.apiPrefix}/event/${id}`);

    return res.data;
  }

  public async createNationalEvent(data: ApiCreateNationalEventsInterface): Promise<boolean> {
    const res = await this.axios.post(this.apiPrefix, data);

    return res.status === 201;
  }

  public async updateNationalEvent(data: ApiUpdateNationalEventsInterface): Promise<void> {
    await this.axios.patch(this.apiPrefix, data);
  }

  public async deleteNationalEvent(id: number): Promise<void> {
    await this.axios.delete(this.apiPrefix, { data: { id } });
  }

  public async getAllMovableMethods(): Promise<string[]> {
    const res = await this.axios.get(`${this.apiPrefix}/movable-methods`);

    return res.data;
  }
}
